import { sortOptions } from "../config/sorting";
export function resolveSortFromFilters(_ref) {
  let {
    filters
  } = _ref;
  return sortOptions.get(filters.get('sort'));
}